import { ticketStatuses } from '../../data-types/sports/sportsConstants';
import { Ticket } from '../../data-types/sports/sportsInterfaces';
import { SystemBetPlacementResult, TicketPresentationDetails } from '../../data-types/ticket/ticketInterfaces';
import { store } from '../store';
import {
  DEQUEUE_ALL_BOOSTED_SYSTEM_BET_TICKET,
  DEQUEUE_ALL_TICKETS,
  DEQUEUE_TICKET,
  ENQUEUE_BOOSTED_SYSTEM_BET_TICKET,
  ENQUEUE_TICKET,
  FLUSH_CASHOUT_OFFER_UPDATES,
  REMOVE_FAILED_SYSTEM_BET_PLACED,
  REMOVE_SPECIFIC_SUCCESS_SYSTEM_BET_PLACE,
  REMOVE_SUCCESS_SYSTEM_BET_PLACED,
  SET_CASHOUT_OFFER_ACCEPTED,
  SET_CASHOUT_OFFER_REJECTED,
  SET_CASHOUT_OFFER_UNAVAILABLE,
  SET_CASHOUT_OFFER_UPDATE,
  SET_FAILED_SYSTEM_BET_PLACED,
  SET_PENDING_TICKET_STATUSES,
  SET_SUCCESS_SYSTEM_BET_PLACED,
} from '../types/ticketTypes';

export const updatePendingTicketStatuses = (ticketId: number, status: number, error?: { errorMessage: string; errorTitle?: string }) => {
  const tickets = { ...store.getState().tickets.pendingTickets };
  tickets[ticketId] = {
    status,
    error,
  };
  store.dispatch({
    type: SET_PENDING_TICKET_STATUSES,
    meta: tickets,
  });
};

export const addPendingTicketStatuses = (ticketId: number) => {
  const tickets = { ...store.getState().tickets.pendingTickets };
  tickets[ticketId] = { status: ticketStatuses.PENDING };
  store.dispatch({
    type: SET_PENDING_TICKET_STATUSES,
    meta: tickets,
  });
};

export const removePendingTicket = (ticketId: number) => {
  const tickets = { ...store.getState().tickets.pendingTickets };
  delete tickets[ticketId];
  store.dispatch({
    type: SET_PENDING_TICKET_STATUSES,
    meta: tickets,
  });
};

export const enqueueTicketForFullScreenPresentation = (ticketPresentationDetails: TicketPresentationDetails) => {
  store.dispatch({
    type: ENQUEUE_TICKET,
    meta: ticketPresentationDetails,
  });
};

export const dequeueTicketFromFullScreenPresentation = () => {
  store.dispatch({
    type: DEQUEUE_TICKET,
  });
};

export const setCashoutOfferUpdate = (ticketId: number, cashoutOffer: number | null) => {
  store.dispatch({
    type: SET_CASHOUT_OFFER_UPDATE,
    meta: { ticketId, cashoutOffer },
  });
};

export const flushCashoutOfferUpdates = () => {
  store.dispatch({
    type: FLUSH_CASHOUT_OFFER_UPDATES,
  });
};

export const setCashoutOfferAccepted = (ticketId: number, boostedCashoutOffer: number | null, accepted: boolean) => {
  store.dispatch({
    type: SET_CASHOUT_OFFER_ACCEPTED,
    meta: { ticketId, boostedCashoutOffer, accepted },
  });
};

export const setCashoutOfferRejected = (ticketId: number, rejected: boolean) => {
  store.dispatch({
    type: SET_CASHOUT_OFFER_REJECTED,
    meta: { ticketId, rejected },
  });
};

export const setCashoutOfferUnavailable = (ticketId: number, unavailable: boolean) => {
  store.dispatch({
    type: SET_CASHOUT_OFFER_UNAVAILABLE,
    meta: { ticketId, unavailable },
  });
};

export const enqueueBoostedSystemBetTicket = (ticket: Ticket) => {
  store.dispatch({
    type: ENQUEUE_BOOSTED_SYSTEM_BET_TICKET,
    meta: ticket,
  });
};

export const dequeueAllBoostedSystemBets = () => {
  store.dispatch({
    type: DEQUEUE_ALL_BOOSTED_SYSTEM_BET_TICKET,
  });
};

export const addSuccessPlacedSystemBets = (systemBet: SystemBetPlacementResult) => {
  store.dispatch({
    type: SET_SUCCESS_SYSTEM_BET_PLACED,
    meta: systemBet,
  });
};

export const addFailedPlacedSystemBets = (systemBet: SystemBetPlacementResult) => {
  store.dispatch({
    type: SET_FAILED_SYSTEM_BET_PLACED,
    meta: systemBet,
  });
};

export const removeAllSuccessPlacedSystemBets = () => {
  store.dispatch({
    type: REMOVE_SUCCESS_SYSTEM_BET_PLACED,
  });
};

export const removeAllFailedPlacedSystemBets = () => {
  store.dispatch({
    type: REMOVE_FAILED_SYSTEM_BET_PLACED,
  });
};

export const removeSpecificSuccessPlacedSystemBet = (systemBetId: number) => {
  store.dispatch({
    type: REMOVE_SPECIFIC_SUCCESS_SYSTEM_BET_PLACE,
    meta: systemBetId,
  });
};

export const dequeueAllTickets = () => {
  store.dispatch({
    type: DEQUEUE_ALL_TICKETS,
  });
};
